import { computed } from 'vue';export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      // svg名称
      type: String,
      required: true
    },
    className: {
      // svg样式
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    }
  }
};